import styles from "./main.module.css"
const Main = (props) => {
    return (
        <section className={`${styles.ctn} ${props.className}`} id={`sm5-active${props.activeIndex}`}>
            <h2 className="sm5-active-fade-in-element">{props.h}</h2>
            <div>{props.children}</div>
        </section>
    )
}

export default Main